// src/components/WishlistPage.jsx
import React from 'react';

const WishlistPage = ({ 
  wishlistItems, 
  onRemoveFromWishlist, 
  onAddToCart, 
  onBuyNow,
  onProductSelect,
  currency,
  convertPrice,
  onBack 
}) => {
  if (!wishlistItems || wishlistItems.length === 0) {
    return (
      <div style={{ 
        textAlign: 'center', 
        padding: '4rem 2rem',
        maxWidth: '600px',
        margin: '0 auto'
      }}>
        <div style={{ fontSize: '4rem', marginBottom: '1rem' }}>📚</div>
        <h2 style={{ marginBottom: '1rem', color: '#334155' }}>Your Wishlist is Empty</h2>
        <p style={{ color: '#64748b', marginBottom: '2rem' }}>
          Start adding your favorite books to your wishlist to keep track of what you want to read next!
        </p>
        <button 
          onClick={onBack}
          className="btn primary"
          style={{ marginRight: '1rem' }}
        >
          Continue Shopping
        </button>
      </div>
    );
  }

  return (
    <div className="wishlist-page">
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '2rem' }}>
        <button onClick={onBack} className="btn outline">
          ← Back to Shopping
        </button>
        <h1 style={{ 
          fontFamily: 'Playfair Display, serif',
          fontSize: '2.5rem',
          background: 'linear-gradient(135deg, #334155, #e63946)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          margin: 0
        }}>
          My Wishlist ({wishlistItems.length})
        </h1>
      </div>

      <div className="modern-products-grid">
        {wishlistItems.map(product => (
          <div key={product.id} className="modern-product-card">
            <div className="product-image-container">
              <img 
                src={product.image} 
                alt={product.name}
                className="product-image"
                onError={(e) => {
                  e.target.src = 'https://images.unsplash.com/photo-1544716278-ca5e3f4abd8c?w=400&h=600&fit=crop';
                }}
              />
              <div className="product-badges">
                {product.featured && (
                  <div className="featured-badge">Featured</div>
                )}
                <div className="category-badge">
                  {product.category}
                </div>
              </div>
              <button 
                className="wishlist-icon active"
                onClick={() => onRemoveFromWishlist(product.id)}
                title="Remove from wishlist"
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 21.35L10.55 20.03C5.4 15.36 2 12.28 2 8.5C2 5.42 4.42 3 7.5 3C9.24 3 10.91 3.81 12 5.09C13.09 3.81 14.76 3 16.5 3C19.58 3 22 5.42 22 8.5C22 12.28 18.6 15.36 13.45 20.04L12 21.35Z" 
                        stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
            </div>
            
            <div className="product-content">
              <div className="product-header">
                <h3 className="product-title" onClick={() => onProductSelect(product)}>
                  {product.name}
                </h3>
                <p className="product-author">by {product.author}</p>
              </div>
              
              <p className="product-description">{product.description}</p>
              
              <div className="product-details-list">
                <div className="detail-item">
                  <span className="detail-label">Pages:</span>
                  <span>{product.pages || 'N/A'}</span>
                </div>
                <div className="detail-item">
                  <span className="detail-label">Language:</span>
                  <span>{product.language || 'English'}</span>
                </div>
                <div className="detail-item">
                  <span className="detail-label">Year:</span>
                  <span>{product.year || 'N/A'}</span>
                </div>
                <div className="detail-item">
                  <span className="detail-label">Stock:</span>
                  <span className={product.stock_quantity > 10 ? 'in-stock' : product.stock_quantity > 0 ? 'low-stock' : 'out-of-stock'}>
                    {product.stock_quantity > 0 ? `${product.stock_quantity} available` : 'Out of stock'}
                  </span>
                </div>
              </div>
              
              <div className="product-meta">
                <div className="product-rating">
                  {'★'.repeat(Math.floor(product.rating))}
                  {'☆'.repeat(5 - Math.floor(product.rating))}
                  <span>({product.rating})</span>
                </div>
                <div className="product-price">
                  {convertPrice(product.price)}
                </div>
              </div>
              
              <div className="product-actions">
                <button 
                  className="btn add-to-cart"
                  onClick={() => onAddToCart(product)}
                  disabled={product.stock_quantity <= 0}
                >
                  Add to Cart
                </button>
                <button 
                  className="btn buy-now"
                  onClick={() => onBuyNow(product)}
                  disabled={product.stock_quantity <= 0}
                >
                  Buy Now
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WishlistPage;